/**
 * Formatting utilities
 */

// Re-export date formatting functions
export { formatDate, formatShortDate } from './date';

/**
 * Format user role for display
 */
export function formatRole(role: string): string {
  const roleMap: Record<string, string> = {
    systemadmin: 'Systemadministrator',
    admin: 'Administrator',
    member: 'Medlem',
  };

  return roleMap[role] || role;
}

/**
 * Format study plan status for display
 */
export function formatStatus(status: string): string {
  const statusMap: Record<string, string> = {
    draft: 'Utkast',
    submitted: 'Innsendt',
    under_review: 'Under vurdering',
    approved: 'Godkjent',
    rejected: 'Avvist',
  };

  return statusMap[status] || status;
}

/**
 * Get status color class
 */
export function getStatusColor(status: string): string {
  const colorMap: Record<string, string> = {
    draft: 'text-gray-600 bg-gray-100',
    submitted: 'text-kf-primary bg-kf-primary-20',
    under_review: 'text-kf-warning bg-kf-accent-20',
    approved: 'text-green-600 bg-green-100',
    rejected: 'text-red-600 bg-red-100',
  };

  return colorMap[status] || 'text-gray-600 bg-gray-100';
}

/**
 * Format validation score as percentage
 */
export function formatScore(score: number): string {
  return `${score.toFixed(1)}%`;
}

/**
 * Format ECTS credits
 */
export function formatECTS(ects: number): string {
  return `${ects} KP (ECTS)`;
}

/**
 * Format hours
 */
export function formatHours(hours: number): string {
  return `${hours} timer`;
}

/**
 * Truncate text with ellipsis
 */
export function truncate(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength) + '...';
}

/**
 * Format file size
 */
export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 Bytes';

  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
}
